import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemAuditingRoute: InvariantJiraRoute = {
	name: 'global-settings-system-auditing',
	path: '/auditing/:page',
};
